export default "__VITE_PUBLIC_ASSET__f42db9eb__"